import './ReverseHeader.scss';

import { Typography } from '@modulor/react';
import type { FC, ReactNode } from 'react';
import { getPathPrefix } from 'utils';

interface ReverseHeaderProps {
  title: ReactNode;
  subtitle: ReactNode;
  children?: ReactNode;
}

export const ReverseHeader: FC<ReverseHeaderProps> = ({ title, subtitle, children }) => (
  <div className="reverse-header">
    <img alt="" className="reverse-header__image" src={`${getPathPrefix()}/assets/withdrawal-reject-money-bag.webp`} />
    <div className="reverse-header__text">
      <Typography variant="title-1-bold" className="reverse-header__title">
        {title}
      </Typography>
      <Typography variant="subhead-regular" className="reverse-header__subtitle">
        {subtitle}
      </Typography>
    </div>
    {children}
  </div>
);
